async function cartSubmitHandler(e) {
  e.preventDefault();
  const submitButtons = document.querySelectorAll('[type="submit"]');
  submitButtons.forEach((btn) => {
    btn.classList.add('btn--loading');
    btn.disabled = true;
  });

  const form =
    document.getElementById('cart') || document.getElementById('cart-drawer');

  if (!form) {
    alert('Error happened - Form not exists');
    return;
  }

  const formData = new FormData(form);
  let pickupMethod, pickupDate, pickupTime, pickupLocation;

  for (const [key, value] of formData.entries()) {
    if (key.includes('shipping_method')) {
      pickupMethod = value;
    }
    if (key.includes('pickup_date')) {
      pickupDate = value;
    }

    if (key.includes('pickup_time')) {
      pickupTime = value;
    }

    if (key.includes('pickup_location')) {
      pickupLocation = value;
    }
  }

  // if (
  //   pickupMethod === 'pickup' &&
  //   (!pickupDate || !pickupTime || !pickupLocation)
  // ) {
  //   alert(
  //     '픽업 정보를 모두 입력해주세요.\nPlease fill out all pickup information.'
  //   );
  //   submitButtons.forEach((btn) => {
  //     btn.classList.remove('btn--loading');
  //     btn.disabled = false;
  //   });
  //   return;
  // }

  // 초기화
  const prevCartData = await fetch('/cart.js').then((res) => res.json());

  const params = new URLSearchParams();
  for (const key in prevCartData.attributes) {
    params.append(`attributes[${key}]`, '');
  }

  for (const [key, value] of formData.entries()) {
    params.append(key, value.toString());
  }

  try {
    await fetch('/cart', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: params,
    });

    const cartRes = await fetch('/cart.json');
    const cartData = await cartRes.json();

    console.log(cartData);
    const draftOrderRes = await fetch(
      'https://gandago-seller.vercel.app/api/shopify/draft-order',
      {
        method: 'POST',
        body: JSON.stringify(cartData),
      }
    );
    const data = await draftOrderRes.json();

    if (data?.draftOrder?.invoiceUrl) {
      submitButtons.forEach((btn) => {
        btn.classList.remove('btn--loading');
        btn.disabled = false;
      });
      window.location.href = data?.draftOrder.invoiceUrl;
    } else {
      console.log(data);
      submitButtons.forEach((btn) => {
        btn.classList.remove('btn--loading');
        btn.disabled = false;
      });
      alert('An error occured');
    }
  } catch (error) {
    console.error(error);
    alert('An error occured');
    submitButtons.forEach((btn) => {
      btn.classList.remove('btn--loading');
      btn.disabled = false;
    });
  }
}

class CartDrawer extends DrawerComponent {
  constructor() {
    super();
    window.WhaleKitSections = WhaleTheme.utils.getSectionId(this);

    this.onCartRefreshListener = this.onCartRefresh.bind(this);
    this.getSectionToRenderListener = this.getSectionToRender.bind(this);

    const form = document.getElementById('cart-drawer');
    form.addEventListener('submit', cartSubmitHandler);
  }

  get requiresBodyAppended() {
    return false;
  }

  get sectionId() {
    return this.getAttribute('data-section-id');
  }

  connectedCallback() {
    super.connectedCallback();

    document.addEventListener(
      'cart:grouped-sections',
      this.getSectionToRenderListener
    );
    document.addEventListener('cart:refresh', this.onCartRefreshListener);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(
      'cart:grouped-sections',
      this.getSectionToRenderListener
    );
    document.removeEventListener('cart:refresh', this.onCartRefreshListener);
  }

  getSectionToRender(event) {
    event.detail.sections.push(WhaleTheme.utils.getSectionId(this));
  }

  show(focusElement = null, animate = true) {
    super.show(focusElement, animate);

    if (this.open) {
      WhaleTheme.a11y.trapFocus(this, this.focusElement);
    }
  }

  async onCartRefresh(event) {
    const cartId = `CartDrawer-${this.sectionId}`;

    const cartElement = document.getElementById(cartId);
    if (!cartElement) return;

    try {
      const response = await fetch(
        `${WhaleTheme.routes.root_url}?section_id=${this.sectionId}`
      );
      const responseText = await response.text();

      const parser = new DOMParser();
      const parsedHTML = parser.parseFromString(responseText, 'text/html');

      const newCartContent = parsedHTML.getElementById(cartId).innerHTML;
      cartElement.innerHTML = newCartContent;

      if (event.detail.open === true) {
        this.show();
      }
    } catch (error) {
      console.error('Error refreshing cart:', error);
    }
  }
}
customElements.define('cart-drawer', CartDrawer);

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.addEventListener(
      'change',
      WhaleTheme.utils.debounce(this.onChange.bind(this), 300)
    );
    this.cartUpdateUnsubscriber = WhaleTheme.pubsub.subscribe(
      WhaleTheme.pubsub.PUB_SUB_EVENTS.cartUpdate,
      this.onCartUpdate.bind(this)
    );

    this.cartItemProducts = this.querySelectorAll('.cart-item__product');
    this.cartItemQuantitys = this.querySelectorAll('.cart-item__quantity');

    const loadTemplateContent = (elements, parentSelector) => {
      elements.forEach((element) => {
        const template = element.querySelector('template');
        const templateContent =
          template && document.importNode(template.content, true);
        const parent = element.querySelector(parentSelector);

        if (parent && template && !parent.querySelector('.template-content')) {
          const contentWrapper = document.createElement('div');
          contentWrapper.classList.add('template-content', 'w-full');
          contentWrapper.appendChild(templateContent);
          parent.appendChild(contentWrapper);
        }
      });
    };

    const removeTemplateContent = (elements, parentSelector) => {
      elements.forEach((element) => {
        const parent = element.querySelector(parentSelector);
        const templateContent = parent?.querySelector('.template-content');

        if (templateContent) {
          parent.removeChild(templateContent);
        }
      });
    };

    const handleTabletMatch = () => {
      loadTemplateContent(this.cartItemProducts, '.cart-item__product--info');
      removeTemplateContent(
        this.cartItemQuantitys,
        '.cart-item__quantity-wrapper'
      );
    };

    const handleTabletUnmatch = () => {
      removeTemplateContent(this.cartItemProducts, '.cart-item__product--info');
      loadTemplateContent(
        this.cartItemQuantitys,
        '.cart-item__quantity-wrapper'
      );
    };

    const mqlTablet = window.matchMedia(WhaleTheme.config.mediaQueryTablet);
    WhaleTheme.config.mqlTablet = mqlTablet.matches;

    if (WhaleTheme.config.mqlTablet) {
      handleTabletMatch();
    } else {
      handleTabletUnmatch();
    }

    mqlTablet.onchange = (event) => {
      if (event.matches) {
        handleTabletMatch();
      } else {
        WhaleTheme.config.mqlTablet = false;
        handleTabletUnmatch();
      }
    };

    window.WhaleKitSections = WhaleTheme.utils.getSectionId(this);
  }

  cartUpdateUnsubscriber = undefined;

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  onChange(event) {
    this.validateQuantity(event);
  }

  setValidity(target, message) {
    target.setCustomValidity(message);
    target.reportValidity();
    target.value = target.defaultValue;
    target.select();
  }

  validateQuantity(event) {
    const target = event.target;

    if (target.type === 'radio' || target.type === 'select-one') {
      return;
    }

    const inputValue = parseInt(target.value);
    const index = target.getAttribute('data-index');
    let message = '';

    if (inputValue < parseInt(target.getAttribute('data-min'))) {
      message = WhaleTheme.quickOrderListStrings.min_error.replace(
        '[min]',
        target.getAttribute('data-min')
      );
    } else if (inputValue > parseInt(target.max)) {
      message = WhaleTheme.quickOrderListStrings.max_error.replace(
        '[max]',
        target.max
      );
    } else if (inputValue % parseInt(target.step) !== 0) {
      message = WhaleTheme.quickOrderListStrings.step_error.replace(
        '[step]',
        target.step
      );
    }

    if (message) {
      this.setValidity(target, message);
    } else {
      target.setCustomValidity('');
      target.reportValidity();
      this.updateQuantity(
        index,
        inputValue,
        document.activeElement.getAttribute('name'),
        target
      );
    }
  }

  onCartUpdate(event) {
    if (event.cart.errors) {
      this.onCartError(event.cart.errors, event.target);
      return;
    }

    const sectionId = WhaleTheme.utils.getSectionId(this);
    const sectionToRender = new DOMParser().parseFromString(
      event.cart.sections[sectionId],
      'text/html'
    );

    const cartDrawer = document.querySelector(`#CartDrawer-${sectionId}`);
    const cartDrawerBody = document.querySelector(
      `#CartDrawerBody-${sectionId}`
    );
    const cartDrawerFooter = document.querySelector(
      `#CartDrawerFooter-${sectionId}`
    );
    const cartDrawerEmpty = document.querySelector(
      `#CartDrawerEmpty-${sectionId}`
    );
    if (cartDrawer) {
      // const updatedElement = sectionToRender.querySelector(`#CartDrawer-${sectionId}`);
      // if (updatedElement) {
      //   cartDrawer.innerHTML = updatedElement.innerHTML;
      // }
      const cartDrawerBodyUpdate = sectionToRender.querySelector(
        `#CartDrawerBody-${sectionId}`
      );
      const cartDrawerFooterUpdate = sectionToRender.querySelector(
        `#CartDrawerFooter-${sectionId}`
      );
      const cartDrawerEmptyUpdate = sectionToRender.querySelector(
        `#CartDrawerEmpty-${sectionId}`
      );

      if (cartDrawerBodyUpdate) {
        cartDrawerBody.innerHTML = cartDrawerBodyUpdate.innerHTML;
      }
      if (cartDrawerFooterUpdate) {
        cartDrawerFooter.innerHTML = cartDrawerFooterUpdate.innerHTML;
      }

      if (cartDrawerEmptyUpdate) {
        cartDrawerEmpty.innerHTML = cartDrawerEmptyUpdate.innerHTML;
      }

      if (event.cart.item_count > 0) {
        cartDrawerBody.classList.remove('hidden');
        cartDrawerFooter.classList.remove('hidden');
        cartDrawerEmpty.classList.add('hidden');
      } else {
        cartDrawerBody.classList.add('hidden');
        cartDrawerFooter.classList.add('hidden');
        cartDrawerEmpty.classList.remove('hidden');
      }
    }

    const mainCart = document.querySelector(`#MainCart-${sectionId}`);
    if (mainCart) {
      const updatedElement = sectionToRender.querySelector(
        `#MainCart-${sectionId}`
      );
      if (updatedElement) {
        mainCart.innerHTML = updatedElement.innerHTML;
      } else {
        mainCart.closest('.cart').classList.add('is-empty');
        mainCart.remove();
      }
    }

    const lineItem =
      document.getElementById(`CartItem-${event.line}`) ||
      document.getElementById(`CartDrawer-Item-${event.line}`);

    if (lineItem && lineItem.querySelector(`[name="${event.name}"]`)) {
      WhaleTheme.a11y.trapFocus(
        mainCart || cartDrawer,
        lineItem.querySelector(`[name="${event.name}"]`)
      );
    } else if (event.cart.item_count === 0) {
      cartDrawer
        ? WhaleTheme.a11y.trapFocus(cartDrawer, cartDrawer.querySelector('a'))
        : WhaleTheme.a11y.trapFocus(
            document.querySelector('.cart__empty'),
            document.querySelector('a')
          );
    } else {
      cartDrawer
        ? WhaleTheme.a11y.trapFocus(
            cartDrawer,
            cartDrawer.querySelector('.cart-item__title')
          )
        : WhaleTheme.a11y.trapFocus(
            mainCart,
            mainCart.querySelector('.cart-item__title')
          );
    }

    document.dispatchEvent(
      new CustomEvent('cart:updated', {
        detail: {
          cart: event.cart,
        },
      })
    );
  }

  onCartError(errors, target) {
    if (target) {
      this.updateQuantity(
        target.getAttribute('data-index'),
        target.defaultValue,
        document.activeElement.getAttribute('name'),
        target
      );
    } else {
      window.location.href = WhaleTheme.routes.cart_url;
    }

    alert(errors);
  }

  updateQuantity(line, quantity, name, target) {
    this.showLoader(line);

    let sectionsToBundle = [];
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:grouped-sections', {
        bubbles: true,
        detail: { sections: sectionsToBundle },
      })
    );

    const body = JSON.stringify({
      line,
      quantity,
      sections: sectionsToBundle,
    });

    fetch(`${WhaleTheme.routes.cart_change_url}`, {
      ...WhaleTheme.utils.fetchConfig(),
      ...{ body },
    })
      .then((response) => response.json())
      .then((parsedState) => {
        WhaleTheme.pubsub.publish(WhaleTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, {
          sources: 'cart-items',
          cart: parsedState,
          target,
          line,
          name,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  }

  showLoader(line) {
    const sectionId = WhaleTheme.utils.getSectionId(this);
    const loaders = document.querySelectorAll(`#Loader-${sectionId}-${line}`);
    if (loaders) {
      loaders.forEach((loader) => {
        loader.classList.add('btn--loading');
      });
    }
  }
}

customElements.define('cart-items', CartItems);

class CartRemoveItem extends HTMLAnchorElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();

      const cartItems = this.closest('cart-items');
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}
customElements.define('cart-remove-item', CartRemoveItem, { extends: 'a' });
class CartNote extends HTMLElement {
  constructor() {
    super();

    this.addEventListener(
      'change',
      WhaleTheme.utils.debounce(this.onChange.bind(this), 300)
    );

    if (this.button && this.cartNoteDetailsSummary) {
      this.button.addEventListener('click', () => {
        this.cartNoteDetailsSummary.close();
      });
    }
  }

  get cartNoteDetailsSummary() {
    return this.closest('[is="accordion-details"]');
  }

  get button() {
    return this.querySelector('[type="button"]');
  }

  onChange(event) {
    const body = JSON.stringify({ note: event.target.value });
    fetch(`${WhaleTheme.routes.cart_update_url}`, {
      ...WhaleTheme.utils.fetchConfig(),
      ...{ body },
    });
  }
}
customElements.define('cart-note', CartNote);

class CalculateShipping extends ModalComponent {
  constructor() {
    super();
    this.countryProvince = this.querySelector('country-province');
    this.isCountrySetup = false;
  }
  static get observedAttributes() {
    return [...super.observedAttributes, 'data-show'];
  }
  show() {
    super.show();
    this.setAttribute('data-show', true);
  }

  hide() {
    super.hide();
    this.setAttribute('data-show', false);
  }

  attributeChangedCallback(name, oldValue, newValue) {
    super.attributeChangedCallback(name, oldValue, newValue);
    if (
      name === 'data-show' &&
      newValue === 'true' &&
      !this.isCountrySetup &&
      this.countryProvince
    ) {
      const template = this.countryProvince.querySelector('template');
      const templateContent = document.importNode(template.content, true);
      this.countryProvince.countryElement.appendChild(templateContent);
      this.countryProvince.init();
      this.isCountrySetup = true;
    }
  }
}
customElements.define('calculate-shipping', CalculateShipping);
class CountryProvinceForm extends HTMLElement {
  constructor() {
    super();
    this.provinceElement = this.querySelector('[name="address[province]"]');
    this.countryElement = this.querySelector('[name="address[country]"]');
    this.template = this.dataset.template;
    this.countryElement.addEventListener(
      'change',
      this.handleCountryChange.bind(this)
    );
    if (this.template && this.template === 'cart') {
      this.init();
    }
  }

  init() {
    if (this.getAttribute('country') !== '') {
      this.countryElement.selectedIndex = Math.max(
        0,
        Array.from(this.countryElement.options).findIndex(
          (option) => option.textContent === this.dataset.country
        )
      );
      this.countryElement.dispatchEvent(new Event('change'));
    } else {
      this.handleCountryChange();
    }
  }

  handleCountryChange() {
    const option =
        this.countryElement.options[this.countryElement.selectedIndex],
      provinces = JSON.parse(option.dataset.provinces);

    this.provinceElement.closest('.form-field').hidden = provinces.length === 0;

    if (provinces.length === 0) {
      return;
    }

    this.provinceElement.innerHTML = '';

    provinces.forEach((data) => {
      const selected = data[1] === this.dataset.province;
      this.provinceElement.options.add(
        new Option(data[1], data[0], selected, selected)
      );
    });
  }
}
customElements.define('country-province', CountryProvinceForm);

class ShippingCalculator extends HTMLFormElement {
  constructor() {
    super();

    this.submitButton = this.querySelector('[type="submit"]');
    this.resultsElement = this.lastElementChild;

    this.submitButton.addEventListener(
      'click',
      this.handleFormSubmit.bind(this)
    );
  }

  handleFormSubmit(event) {
    event.preventDefault();

    const zip = this.querySelector('[name="address[zip]"]').value,
      country = this.querySelector('[name="address[country]"]').value,
      province = this.querySelector('[name="address[province]"]').value;

    this.submitButton.classList.add('btn--loading');

    const body = JSON.stringify({
      shipping_address: { zip, country, province },
    });
    let sectionUrl = `${WhaleTheme.routes.cart_url}/shipping_rates.json`;

    sectionUrl = sectionUrl.replace('//', '/');

    fetch(sectionUrl, {
      ...WhaleTheme.utils.fetchConfig('javascript'),
      ...{ body },
    })
      .then((response) => response.json())
      .then((parsedState) => {
        if (parsedState.shipping_rates) {
          this.formatShippingRates(parsedState.shipping_rates);
        } else {
          this.formatError(parsedState);
        }
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        this.resultsElement.hidden = false;
        this.submitButton.classList.remove('btn--loading');
      });
  }

  formatError(errors) {
    const shippingRatesList = Object.keys(errors).map((errorKey) => {
      return `<li>${errors[errorKey]}</li>`;
    });
    this.resultsElement.innerHTML = `
      <div class="alert alert--error blocks-radius grid gap-2">
        <p class="font-body-bolder m-0">${
          WhaleTheme.shippingCalculatorStrings.error
        }</p>
        <ul class="list-disc grid gap-1 text-sm" role="list">${shippingRatesList.join(
          ''
        )}</ul>
      </div>
    `;
  }

  formatShippingRates(shippingRates) {
    const shippingRatesList = shippingRates.map(
      ({ presentment_name, currency, price }) => {
        return `<li>${presentment_name}: ${currency} ${price}</li>`;
      }
    );
    this.resultsElement.innerHTML = `
      <div class="alert blocks-radius alert--${
        shippingRates.length === 0 ? 'error' : 'success'
      } grid gap-2 leading-tight">
        <p class="font-body-bolder m-0">${
          shippingRates.length === 0
            ? WhaleTheme.shippingCalculatorStrings.notFound
            : shippingRates.length === 1
            ? WhaleTheme.shippingCalculatorStrings.oneResult
            : WhaleTheme.shippingCalculatorStrings.multipleResults
        }</p>
        ${
          shippingRatesList === ''
            ? ''
            : `<ul class="list-disc grid gap-1 text-sm" role="list">${shippingRatesList.join(
                ''
              )}</ul>`
        }
      </div>
    `;
  }
}
customElements.define('shipping-calculator', ShippingCalculator, {
  extends: 'form',
});

class CartDrawerProductsRecommendation extends HTMLElement {
  constructor() {
    super();
    if ('requestIdleCallback' in window) {
      requestIdleCallback(this.init.bind(this), { timeout: 1500 });
    } else {
      const userAgent = navigator.userAgent;
      const isSafari =
        userAgent.includes('Safari') && !userAgent.includes('Chrome');
      if (isSafari) {
        this.init();
      } else {
        WhaleTheme.Motion.inView(this, this.init.bind(this), {
          margin: '600px 0px 600px 0px',
        });
      }
    }
  }

  get slideContainer() {
    return this.querySelector('.swiper');
  }

  get sliderPagination() {
    return this.querySelector('.swiper-pagination');
  }

  get sliderNext() {
    return this.querySelector('.swiper-button-next');
  }

  get sliderPrev() {
    return this.querySelector('.swiper-button-prev');
  }

  init() {
    fetch(this.dataset.url)
      .then((response) => response.text())
      .then((responseText) => {
        const sectionInnerHTML = new DOMParser()
          .parseFromString(responseText, 'text/html')
          .querySelector('.shopify-section');

        if (sectionInnerHTML === null) return;

        const recommendations = sectionInnerHTML.querySelector(
          'cart-drawer-products-recommendation'
        );
        if (recommendations && recommendations.innerHTML.trim().length) {
          const productCount =
            recommendations.querySelectorAll('.product-card');
          this.innerHTML = recommendations.innerHTML;
          this.initCarousel();
          if (productCount.length > 0) this.classList.remove('hidden');
          this.dispatchEvent(new CustomEvent('recommendations:loaded'));
        } else {
          this.closest('.shopify-section').remove();
          this.classList.add('hidden');
          this.dispatchEvent(new CustomEvent('is-empty'));
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }

  initCarousel() {
    this.carousel = new WhaleTheme.Carousel(this.slideContainer, {
      slidesPerView: 1,
      spaceBetween: 10,
      loop: false,
      pagination: {
        el: this.sliderPagination,
        type: 'fraction',
      },
      navigation: {
        nextEl: this.sliderNext,
        prevEl: this.sliderPrev,
      },
    });

    this.carousel && this.carousel.init();
  }
}

customElements.define(
  'cart-drawer-products-recommendation',
  CartDrawerProductsRecommendation
);

class MainCart extends HTMLElement {
  constructor() {
    super();

    document.addEventListener(
      'cart:grouped-sections',
      this.getSectionToRender.bind(this)
    );

    const form = document.getElementById('cart');
    form.addEventListener('submit', cartSubmitHandler);
  }

  getSectionToRender(event) {
    event.detail.sections.push(WhaleTheme.utils.getSectionId(this));
  }
}
customElements.define('main-cart', MainCart);

class FreeShippingGoal extends HTMLElement {
  constructor() {
    super();
    this.selectors = {
      leftToSpend: '[data-left-to-spend]',
    };
    this.goal =
      Number(this.dataset.minimumAmount) *
        Number(window.Shopify.currency.rate || 1) || 0;
    this.progress = this.querySelector('progress-bar');
    this.money_format = window.WhaleTheme.settings.moneyFormat;
  }

  connectedCallback() {
    this.updateShippingGloal(Number(this.dataset.cartTotal));
    document.addEventListener('cart:updated', (event) => {
      this.updateShippingGloal(event.detail.cart.items_subtotal_price);
    });
  }

  updateShippingGloal(amount) {
    if (amount > 0) {
      this.classList.remove('hidden');
    } else {
      this.classList.add('hidden');
    }

    this.cartTotal = amount / 100;
    this.goalLeft = this.goal - this.cartTotal;
    this.goalDone = this.goalLeft <= 0;

    this.percent = (this.cartTotal * 100) / this.goal;

    if (this.percent >= 100) this.percent = 100;

    if (this.cartTotal >= this.goal) {
      this.progress.style.setProperty('--percent', `${this.percent}%`);
      this.classList.add('free-shipping-goal--done');
      this.progress.dataset.value = this.cartTotal;
      this.progress.dataset.max = this.goal;
    } else {
      let spend = (this.goal - this.cartTotal) * 100;
      this.querySelector(this.selectors.leftToSpend).innerHTML =
        WhaleTheme.Currency.formatMoney(spend, this.money_format);
      this.classList.remove('free-shipping-goal--done');
      this.progress.style.setProperty('--percent', `${this.percent}%`);
      this.progress.dataset.value = this.cartTotal;
      this.progress.dataset.max = this.goal;
    }
  }
}
customElements.define('free-shipping-goal', FreeShippingGoal);

window.WhaleKitAddToCart = async (payload) => {
  if (!payload?.properties?.['_WhaleKit offer']) return;

  const cartJson = await (
    await fetch(`${WhaleTheme.routes.cart_url}`, {
      ...WhaleTheme.utils.fetchConfig(),
    })
  ).json();
  cartJson['sections'] = payload['sections'];
  WhaleTheme.pubsub.publish(WhaleTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, {
    cart: cartJson,
  });

  document.dispatchEvent(
    new CustomEvent('product-ajax:added', {
      detail: {
        product: payload,
      },
    })
  );
};

// For Cart UI
document.addEventListener('DOMContentLoaded', function () {
  const mainCart = document.getElementById('cart');
  const cartDrawer = document.getElementById('cart-drawer');
  mainCart?.addEventListener('change', cartUpdateHandler);
  cartDrawer?.addEventListener('change', cartUpdateHandler);
  document.addEventListener('cart:updated', updateShippingPickupUI);

  updateTotalShipping();
  updateShippingPickupUI();
});

function cartUpdateHandler(e) {
  const radio = e.target;
  if (
    radio.matches('input[type="radio"][name^="attributes[shipping_method_"]')
  ) {
    const vendorKey = radio.name.match(
      /attributes\[shipping_method_(.+?)\]/
    )?.[1];
    const vendorName = vendorKey.replace(/_/g, ' ');
    const pickupSection = document.querySelector(
      `.pickup-options[data-vendor="${vendorName}"]`
    );

    // Change UI by shipping method
    const shippingGoalSection = document.getElementById(
      `free-shipping-goal-${vendorKey}`
    );
    const isPickup = radio.value === 'pickup';
    pickupSection.classList.toggle('hidden', !isPickup); // Hide unless it's pickup
    shippingGoalSection &&
      shippingGoalSection.classList.toggle('hidden', isPickup); // Hide if it's pickup

    // Render shipping rate
    const shippingRow = document.getElementById(`shipping-rate-${vendorKey}`);
    const shippingPriceSpan = shippingRow?.querySelector('span:last-child');
    const rate = shippingRow?.getAttribute('data-shipping-rate') || '0';
    const freeShippingText =
      shippingRow?.getAttribute('data-free-shipping-text') || 'Free';

    if (shippingPriceSpan) {
      shippingPriceSpan.textContent = isPickup
        ? freeShippingText
        : formatMoney(rate * 100);
    }

    updateTotalShipping();

    // 선택한 배송 방법을 cart.attributes에 저장
    const formData = new FormData();
    formData.append(`attributes[shipping_method_${vendorKey}]`, radio.value);

    fetch('/cart/update.js', {
      method: 'POST',
      body: formData,
    });
  }
}

function updateTotalShipping() {
  let totalShipping = 0;

  document.querySelectorAll('.shipping-rate').forEach((row) => {
    const vendorKey = row.dataset.vendor?.replace(/ /g, '_');
    const selectedMethod = document.querySelector(
      `input[name="attributes[shipping_method_${vendorKey}]"]:checked`
    )?.value;
    const pickupEnabled = row.dataset.pickupEnabled;

    if (pickupEnabled === 'false' || selectedMethod === 'delivery') {
      const rateText = row.dataset.shippingRate || '0';
      const numericRate = parseFloat(rateText.replace(/[^0-9.]/g, '')) || 0;
      totalShipping += numericRate;
    }
  });

  // hidden input 업데이트
  const shippingInput = document.getElementById('total_shipping');
  if (shippingInput) {
    shippingInput.value = totalShipping.toFixed(2);
  }

  // 총액 UI 업데이트
  const subtotalEl = document.querySelector('.totals__subtotal-value');
  const subtotalRaw = parseFloat(subtotalEl?.dataset.subtotal || 0); // subtotal은 따로 data-subtotal로 지정해줘야 해!
  if (subtotalEl) {
    subtotalEl.textContent = formatMoney((subtotalRaw + totalShipping) * 100);
  }
}

function formatMoney(cents, currency = 'USD') {
  const amount = (cents / 100).toFixed(2);
  return new Intl.NumberFormat(undefined, {
    style: 'currency',
    currency,
  }).format(amount);
}

function updateShippingPickupUI() {
  // bindAllCalendars();
  fetch('/cart.js')
    .then((res) => res.json())
    .then((cart) => {
      const attrs = cart.attributes || {};

      Object.entries(attrs).forEach(([key, value]) => {
        if (key.startsWith('shipping_method_')) {
          const vendor = key.replace('shipping_method_', '');
          const radio = document.querySelector(
            `input[name="attributes[shipping_method_${vendor}]"][value="${value}"]`
          );
          if (radio) {
            radio.checked = true;
            radio.dispatchEvent(new Event('change', { bubbles: true })); // 트리거해서 UI 동기화
          }
        }

        // if (key.startsWith('pickup_date_')) {
        //   const vendor = key.replace('pickup_date_', '');
        //   const vendorName = vendor.replaceAll('_', ' ');
        //   const label = document.querySelector(`.pickup-date-label[data-vendor="${vendorName}"]`);
        //   if (label) {
        //     label.textContent = value;
        //   }

        //   // 👉 renderCalendar를 호출해서 시간 옵션도 같이 렌더
        //   const vendorList = document.getElementById('vendor_list');
        //   const rawVendors = JSON.parse(vendorList.dataset.vendors);
        //   const vendorData = rawVendors.find(v => v.includes(vendorName));

        //   if (vendorData) {
        //     const vendorInfo = vendorData.split('|')[0].split(',');
        //     const vendorName = vendorInfo[0];
        //     const timeslots = JSON.parse(vendorInfo[9]?.replaceAll('.', ',').replaceAll('&quot;', '"'));
        //     const offdates = JSON.parse(vendorInfo[10]?.replaceAll('.', ',').replaceAll('&quot;', '"'));

        //     // 날짜 스트링을 Date 객체로 변환, date 선택 이벤트 트리거
        //     const dateObj = new Date(`${value}T00:00:00`);
        //     renderCalendar(dateObj, vendorName, timeslots, offdates);

        //     const dateBtn = document.querySelector(`.calendar-days[data-vendor="${vendorName}"] button[data-date="${value}"]`);

        //     if (dateBtn) {
        //       dateBtn.dispatchEvent(new Event('click', { bubbles: true }));
        //     }

        //     // 📌 render 이후에 pickup_time select를 찾고, 값 지정
        //     const timeSelect = document.querySelector(`.pickup-time[data-vendor="${vendorName}"]`);
        //     const timeValue = attrs[`pickup_time_${vendor}`];
        //     if (timeSelect && timeValue) {
        //       timeSelect.value = timeValue;
        //       // timeSelect.dispatchEvent(new Event('change', { bubbles: true }));
        //     }
        //   }
        // }
      });
    });

  // function bindAllCalendars() {
  //   const vendorList = document.getElementById('vendor_list');
  //   const rawVendors = JSON.parse(vendorList.dataset.vendors);
  //   const vendors = rawVendors.filter((vendor) => !!vendor);

  //   for (vendor of vendors) {
  //     const vendorDetails = vendor.split('|');
  //     const vendorInfo = vendorDetails[0]?.split(',');
  //     const vendorName = vendorInfo[0];
  //     const timeslots = vendorInfo[9] ? JSON.parse(vendorInfo[9].replaceAll('.', ',').replaceAll('&quot;', '"')) : undefined;
  //     const offdates = vendorInfo[10] ? JSON.parse(vendorInfo[10].replaceAll('.', ',').replaceAll('&quot;', '"')) : undefined;

  //     bindCalendars(vendorName, timeslots, offdates);
  //   };
  // }

  // function bindCalendars(vendorName, timeslots, offdates) {
  //   const trigger = document.querySelector(`.pickup-date-trigger[data-vendor="${vendorName}"]`);
  //   const calendar = document.querySelector(`.pickup-calendar[data-vendor="${vendorName}"]`);
  //   const prevMonthBtn = document.querySelector(`.prev-month[data-vendor="${vendorName}"]`);
  //   const nextMonthBtn = document.querySelector(`.next-month[data-vendor="${vendorName}"]`);

  //   const current = new Date();

  //   trigger?.addEventListener('click', () => {
  //     calendar.classList.toggle('hidden');
  //   });

  //   prevMonthBtn?.addEventListener('click', () => {
  //     current.setMonth(current.getMonth() - 1);
  //     if (timeslots && offdates) {
  //       renderCalendar(current, vendorName, timeslots, offdates);
  //     }
  //   });

  //   nextMonthBtn?.addEventListener('click', () => {
  //     current.setMonth(current.getMonth() + 1);
  //     if (timeslots && offdates) {
  //       renderCalendar(current, vendorName, timeslots, offdates);
  //     }
  //   });

  //   document.addEventListener('click', (e) => {
  //     if (calendar && trigger && !calendar.contains(e.target) && !trigger.contains(e.target)) {
  //         calendar.classList.add('hidden');
  //     }
  //   });

  //   if (timeslots && offdates) {
  //     renderCalendar(current, vendorName, timeslots, offdates);
  //   }
  // }

  // function renderCalendar(date, vendorName, timeSlots = [], offdates = []) {
  //   const calendar = document.querySelector(`.pickup-calendar[data-vendor="${vendorName}"]`);
  //   const daysContainer = document.querySelector(`.calendar-days[data-vendor="${vendorName}"]`);
  //   const monthLabel = document.querySelector(`.calendar-month[data-vendor="${vendorName}"]`);
  //   const timeContainer = document.querySelector(`.pickup-time[data-vendor="${vendorName}"]`);

  //   const vendorKey = vendorName.replaceAll(' ', '_');
  //   const dateInputName = `attributes[pickup_date_${vendorKey}]`;

  //   // 제한 요일 (일=0 ~ 토=6), 제외 날짜 목록
  //   const allowedDays = [];

  //   for (day in timeSlots) {
  //       if (timeSlots[day]?.length) {
  //           allowedDays.push(parseInt(day));
  //       }
  //   }

  //   daysContainer.innerHTML = '';

  //   const year = date.getFullYear();
  //   const month = date.getMonth();

  //   const firstDay = new Date(year, month, 1);
  //   const lastDay = new Date(year, month + 1, 0);
  //   const startDay = firstDay.getDay();

  //   const dateStr = date.toLocaleDateString(undefined, { year: 'numeric', month: 'long' })
  //   monthLabel.textContent = dateStr;

  //   // 공백 채우기
  //   for (let i = 0; i < startDay; i++) {
  //     const blank = document.createElement('button');
  //     blank.disabled = true;
  //     blank.type = 'button';
  //     blank.style.padding = '0.5rem';
  //     blank.style.borderRadius = '6px';
  //     blank.style.border = 'none';
  //     blank.style.cursor = 'pointer';
  //     blank.visibility = 'hidden';
  //     daysContainer.appendChild(blank);
  //   }

  //   const today = new Date();
  //   today.setHours(0, 0, 0, 0); // 시간 제거

  //   const excludedDates = (offdates || []).map((d) => d.split('T')[0]);

  //   for (let d = 1; d <= lastDay.getDate(); d++) {
  //     const fullDate = new Date(year, month, d);
  //     const maxDate = new Date(today.getFullYear(), today.getMonth() + 1, today.getDate());

  //     fullDate.setHours(0, 0, 0, 0); // 시간 제거
  //     const dateStr = fullDate.toISOString().split('T')[0];
  //     const day = fullDate.getDay();

  //     const btn = document.createElement('button');
  //     btn.type = 'button';
  //     btn.textContent = d;
  //     btn.style.padding = '0.5rem';
  //     btn.style.borderRadius = '6px';
  //     btn.style.border = 'none';
  //     btn.style.cursor = 'pointer';
  //     btn.setAttribute('data-date', dateStr);

  //     const isAllowed = allowedDays.includes(day);
  //     const isExcluded = excludedDates.includes(dateStr);
  //     const isPast = fullDate < today;
  //     const isTooFar = fullDate > maxDate;

  //     if (!isAllowed || isExcluded || isPast || isTooFar) {
  //       btn.disabled = true;
  //       btn.style.opacity = '0.2';
  //       btn.style.cursor = 'not-allowed';
  //     } else {
  //       btn.addEventListener('click', () => {
  //         document.querySelectorAll(`.calendar-days[data-vendor="${vendorName}"] button`).forEach(b => {
  //             b.style.backgroundColor = '';
  //             b.style.color = '';
  //         });

  //         btn.style.backgroundColor = '#000';
  //         btn.style.color = '#fff';

  //         document.querySelector(`.pickup-date-label[data-vendor="${vendorName}"]`).textContent = dateStr;
  //         calendar.classList.add('hidden');

  //         // 선택된 날짜를 cart attributes에 저장할 hidden input 생성 또는 갱신
  //         let existingInput = document.querySelector(`input[name="${dateInputName}"]`);
  //         if (!existingInput) {
  //           existingInput = document.createElement('input');
  //           existingInput.type = 'hidden';
  //           existingInput.name = dateInputName;
  //           document.querySelectorAll('form.cart__form').forEach((item) => {
  //             item.appendChild(existingInput);
  //             });
  //         }
  //         existingInput.value = dateStr;

  //         // ✅ 날짜 선택 시 cart에 저장
  //         const formData = new FormData();
  //         formData.append(dateInputName, dateStr);
  //         fetch('/cart/update.js', {
  //           method: 'POST',
  //           body: formData,
  //         });

  //         // ✅ 시간 옵션 렌더링
  //         if (timeSlots[day.toString()]) {
  //           timeContainer.innerHTML =
  //             '<option value="" disabled selected>시간을 선택하세요</option>' +
  //             timeSlots[day.toString()]
  //               .map((time) => `<option value="${time.replaceAll(' ', '')}">${time}</option>`)
  //               .join('');
  //         } else {
  //             timeContainer.innerHTML = '<option value="" disabled selected>선택 가능한 시간이 없습니다</option>';
  //         }

  //         // ✅ 시간 선택 시 cart에 저장
  //         const vendorKey = vendorName.replaceAll(' ', '_');
  //         const timeInputName = `attributes[pickup_time_${vendorKey}]`;

  //         const updatedTimeSelect = document.querySelector(`.pickup-time[data-vendor="${vendorName}"]`);
  //         updatedTimeSelect?.addEventListener('change', (e) => {
  //           const selectedTime = e.target.value;
  //           const formData = new FormData();
  //           formData.append(timeInputName, selectedTime);

  //           fetch('/cart/update.js', {
  //             method: 'POST',
  //             body: formData,
  //           });
  //         });
  //       });
  //     }

  //     daysContainer.appendChild(btn);
  //   }
}
